// Clickable row for one transfer source on the list page

export function TransferSourceListItem({ source, onSelect }) {
  return (
    <button
      type="button"
      className="transfer-source-list-item"
      onClick={() => onSelect(source)}
    >
      <span className="transfer-source-list-item__icon" aria-hidden>
        <i className={source.listIconClass ?? 'fa-solid fa-store'} />
      </span>
      <span className="transfer-source-list-item__label">{source.displayName}</span>
      <span className="transfer-source-list-item__chevron" aria-hidden>
        <i className="fa-solid fa-chevron-right" />
      </span>
    </button>
  );
}
